import { Route, Switch } from "react-router";
import DailyTimeSheetTable from "./DailyTimeSheetTable";
import DailyTimeSheetForm from "./DailyTimeSheetForm";
import WriteRoute from "../../shared/components/WriteRoute";

export default () => (
  <Switch>
    <Route exact path="/dailytimesheet" component={DailyTimeSheetTable} />
    <WriteRoute
      exact
      path="/dailytimesheet/addnew"
      component={DailyTimeSheetForm}
      redirectTo="/dailytimesheet"
    />
  </Switch>
);
